import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolders: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolders"><Path fillRule="evenodd" clipRule="evenodd" d="M12.4142 3H5V7H1V21H19V17H23V5H14.4142L12.4142 3ZM19 15H21V7H13.5858L11.5858 5H7V7H8.41421L10.4142 9H19V15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolders;
